export default {
	title: "Spiritual Lines",
	name: "Name",
	primaryColor: "Primary Color",
	description: "Description",
	create: "New Spiritual Line",
	edit: "Edit Spiritual Line",
	confirmDeleteMessage: "Are you sure you want to delete the spiritual line \"{name}\"?",
	stats: {
		total: "Total Lines",
	},
	delete: {
		hasLinksWarning: "This line has {guides} guide(s) and {ritualTypes} ritual type(s) linked to it. They will be moved to the selected line before deletion.",
		reassignLabel: "Move guides and ritual types to",
		reassignAndDelete: "Move and delete",
		noTargetLines: "No other line available for reassignment",
	},
	messages: {
		createSuccess: "Spiritual line created successfully",
		updateSuccess: "Spiritual line updated successfully",
		deleteSuccess: "Spiritual line deleted successfully",
		reassignDeleteSuccess: "Items reassigned and spiritual line deleted successfully",
		createError: "Error creating spiritual line",
		updateError: "Error updating spiritual line",
		deleteError: "Error deleting spiritual line",
		loadError: "Error loading spiritual lines",
	},
	searchPlaceholder: "Search spiritual lines...",
	noData: "No spiritual lines found",
	noDataSubtext: "Start by creating your first spiritual line",
	searchNoResults: "No lines found for '{search}'",
	form: {
		description: "Description",
		icon: "Icon",
		name: "Line Name",
		primaryColor: "Primary Color",
	},
	validation: {
		nameRequired: "Name is required",
		nameMaxLength: "Name must have at most 100 characters",
		descriptionMaxLength: "Description must have at most 500 characters",
	},
};
